import { Box, Typography } from '@mui/material';

export const EmptyBlockedUsers = () => (
  <Box className="flex flex-col items-center gap-5 mt-[92px]">
    <Typography className="text-[36px] text-gray-4 font-extrabold">
      There are no blocked users 🙌
    </Typography>
    <Typography align="center" className="text-gray-4 md:w-[523px] sm:w-[90%]">
      Seems like your community is healthy and thriving. Let’s keep it this way.
    </Typography>
  </Box>
);
